import { useState } from 'react';
import { useSelector } from 'react-redux';
import { FilterDropdown } from 'palette/candidates/Filters';
import { SearchInput } from 'palette/SearchInput';
import { Small } from 'palette/Typography';
import { FilterTopLabel } from '@common/Filters/components/FilterTopLabel';
import { useTranslation } from '@common/Hooks/useTranslation';
import { BrandFilterItems } from '../components/BrandFilterItems';
import { prepareBrandsFilters } from '../helpers';
import { filterSelectors } from '../selectors';
import './BrandFilterDropdown.scss';

function BrandFilterDropdown({ brandGroupsData, activeBrandIds }) {
    const translate = useTranslation();
    const [searchQuery, setSearchQuery] = useState('');
    const { allBrandFilters, availableBrandFilters } = useSelector(filterSelectors.brands);

    const brands = prepareBrandsFilters(allBrandFilters, availableBrandFilters, searchQuery);

    return (
        <FilterDropdown>
            <FilterTopLabel
                filterType="brand"
                label={translate('listing.filterbox.brand.header')}
            />
            <div className="px-24 my-16">
                <SearchInput
                    placeholder={translate('brandwall.search.placeholder')}
                    value={searchQuery}
                    onChange={event => setSearchQuery(event.target.value)}
                />
                {
                    brands.length === 0 && (
                        <Small
                            className="d-block mt-16"
                            color="light"
                        >
                            {translate('brand.filter.quick_search.no_results.label')}
                        </Small>
                    )
                }
            </div>
            <BrandFilterItems
                activeBrandIds={activeBrandIds}
                brandGroupsData={brandGroupsData}
                brands={brands}
            />
        </FilterDropdown>
    );
}

export default BrandFilterDropdown;
